export const REFRESH_TOKEN_HEADER = "x-auth-token";
export const DEV_AUTH_COOKIE = "dev_auth_data";
export const STAGE_AUTH_COOKIE = "stage_auth_data";
export const QA_AUTH_COOKIE = "qa_auth_data";
export const PROD_AUTH_COOKIE = "prod_auth_data";
export const AUTH_COOKIE = "auth_data";
export const HEADER_LANGUAGE = "EN";
export const HEADER_APP_TYPE = "WEB_PORTAL";
export const HTTP_TIMEOUT_DURATION = 300 * 1000;

export const PENDING = "/pending";
export const REJECTED = "/rejected";
export const FULLFILLED = "/fulfilled";

export const USER_TYPES = {
  USER: 1,
  ADMIN: 2,
  SUPER_ADMIN: 4,
  ORGANIZATION_ADMIN: 5
};
